/**
 * @internal Аналог `useIsMobile()` из `@sravni/react-utils` / DeviceInfoProvider
 * для non-React контекста (thunk, prepare, утилиты): mobile = не desktop (`min-width: 1024px`).
 *
 * В React-коде предпочитай `useIsMobile()`.
 * Контракт с хуком закреплён тестом `getIsMobileViewport.syncWithUseIsMobile.spec.tsx`.
 */
export const getIsMobileViewport = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return !window.matchMedia('(min-width: 1024px)').matches;
};
